import styled from 'styled-components';

export const SelectFieldWrapper = styled.div`
  > div {
    ${({ hasLabel }) => !hasLabel && 'margin-top: 0 !important;'}
  }
`;
